export enum ERooms {
  One = 'one',
  Two = 'two',
  Three = 'three',
  FourPlus = 'fourPlus',
}
